import React from "react";
import { Row, Col } from "react-materialize";
import { Link } from "react-router-dom";
import { CheckAuth, BASE_URL } from "../Util";
import Page from "../Page";
import { trans } from "../Lang";

import jsonData from "../../assets/publications.json";

class PublicationItem extends React.Component {
  render() {
    let data = this.props;

    return (
      <Col m={3} s={12} className={"mb-s"}>
        <a href={data.url}>
          <div className="bg-white pub-border">
            <img src={BASE_URL + data.src} alt="blog_picture" />
            <div className="pad-s">
              <h3 className="course-role">{data.title}</h3>
              <br />
            </div>
          </div>
        </a>
      </Col>
    );
  }
}

class Publication extends Page {
  constructor(props) {
    super(props);
    this.scrollToTop();
    this.state = {
      publications: jsonData.publications,
    };
  }

  render() {
    let dataIsEmpty = this.state.publications.length == 0;
    let publications = this.state.publications.filter(
      (item) => item.lang.indexOf(trans.getLanguage()) >= 0
    );

    return (
      <div>
        <div className="bg-blue">
          <Row className="container text-center pad-s">
            <h3 className="font-white page-title">{trans.publication}</h3>
          </Row>
        </div>
        {!dataIsEmpty && (
          <div>
            <Row className="pad-s container">
              {publications.map((item) => (
                <PublicationItem
                  url={item.url}
                  src={item.src}
                  title={item.title}
                />
              ))}
            </Row>
            <Row className="pad-s container">
              <p style={{fontStyle: 'italic'}}>
                Catatan : Materi publikasi masih menggunakan materi sementara, kini sedang dalam tahap finalisasi.
              </p>
            </Row>
          </div>
        )}
        {dataIsEmpty && (
          <div className="container">
            <p className="no-content center">
              Mohon maaf, belum ada publikasi yang dapat kamu download saat ini
              ☹
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default Publication;



// WEBPACK FOOTER //
// ./src/components/Publication/Publication.js